import {createContext, useContext, useState} from 'react';

import useNavigateReplace from '../hooks/useNavigateReplace';

const NavigationContext = createContext(null);

const NavigationProvider = ({children}) => {
    const navigate = useNavigateReplace();

    const [routeState, setRouteState] = useState(null);

    const resetRouteState = () => setRouteState(null);

    const setBackRoute = (route) => setRouteState((prev) => ({...prev, backRoute: route}));

    const onNavigationHandler = (defaultRoute) => {
        const route = routeState?.backRoute || defaultRoute;

        if (route) navigate(route);

        resetRouteState();
    };

    return (
        <NavigationContext.Provider value={{setBackRoute, onNavigationHandler}}>{children}</NavigationContext.Provider>
    );
};

const useNavigationState = ({defaultRoute} = {}) => {
    const {onNavigationHandler, ...rest} = useContext(NavigationContext) || {};

    const onNavigationClick = () => onNavigationHandler(defaultRoute);

    return {...rest, onNavigationClick};
};

export {NavigationProvider, useNavigationState};
